
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/eventDetails';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <a href=\"";
  if (helper = helpers.fullDetailsURL) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.fullDetailsURL); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"view_event_link\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n      ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n      ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <div class=\"series-natural-language\">";
  if (helper = helpers.series_natural_language) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.series_natural_language); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n      ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <tr>\n          <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.calendar", "Source Calendar", options) : helperMissing.call(depth0, "t", "calendar.event_details.calendar", "Source Calendar", options)))
    + "</th>\n          <td>\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.contextInfo)),stack1 == null || stack1 === false ? stack1 : stack1.can_view_context), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.actualContextInfo), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </td>\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isGreaterThanOne), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </tr>\n      ";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n              <a href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.contextInfo)),stack1 == null || stack1 === false ? stack1 : stack1.url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.contextInfo)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a>\n            ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n              "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.contextInfo)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n            ";
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n              <br><span class=\"event-details-actual-context\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.actualContextInfo)),stack1 == null || stack1 === false ? stack1 : stack1.name)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</span>\n            ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <td title=\""
    + escapeExpression((helper = helpers.list || (depth0 && depth0.list),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.contextsName), options) : helperMissing.call(depth0, "list", (depth0 && depth0.contextsName), options)))
    + "\">\n              ";
  stack1 = (helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.contextsCount), options) : helperMissing.call(depth0, "n", (depth0 && depth0.contextsCount), options));
  buffer += escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'n_contextsCount': (stack1),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "n_contextscount_more_2f708db4", "+ %{n_contextsCount} more", options) : helperMissing.call(depth0, "t", "n_contextscount_more_2f708db4", "+ %{n_contextsCount} more", options)))
    + "\n              <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.list || (depth0 && depth0.list),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.contextsName), options) : helperMissing.call(depth0, "list", (depth0 && depth0.contextsName), options)))
    + "</span>\n            </td>\n          ";
  return buffer;
  }

function program16(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <tr>\n          <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.location", "Location", options) : helperMissing.call(depth0, "t", "calendar.event_details.location", "Location", options)))
    + "</th>\n          <td>";
  if (helper = helpers.location_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.location_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n        </tr>\n      ";
  return buffer;
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <tr>\n                <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.location_address", "Address", options) : helperMissing.call(depth0, "t", "calendar.event_details.location_address", "Address", options)))
    + "</th>\n                <td>";
  if (helper = helpers.location_address) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.location_address); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n              </tr>\n            ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n              <tr>\n                <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "conferencing_6a6d9b55", "Conferencing", options) : helperMissing.call(depth0, "t", "conferencing_6a6d9b55", "Conferencing", options)))
    + "</th>\n                <td><div class=\"conferencing\"></div></td>\n              </tr>\n            ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <tr>\n          <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.details", "Details", options) : helperMissing.call(depth0, "t", "calendar.event_details.details", "Details", options)))
    + "</th>\n          <td class=\"user_content\">\n              <div class=\"event-detail-overflow\">\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.is_appointment_group), {hash:{},inverse:self.program(25, program25, data),fn:self.program(23, program23, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              </div>\n          </td>\n        </tr>\n      ";
  return buffer;
  }
function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                      "
    + escapeExpression((helper = helpers.linkify || (depth0 && depth0.linkify),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.description), options) : helperMissing.call(depth0, "linkify", (depth0 && depth0.description), options)))
    + "\n                  ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                      "
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.description), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.description), options)))
    + "\n                  ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n            <tr id='reservations'>\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </tr>\n      ";
  return buffer;
  }
function program28(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <th id='attendees_header_text'\n               scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.attendees", "Attendees", options) : helperMissing.call(depth0, "t", "calendar.event_details.attendees", "Attendees", options)))
    + "</th>\n              <td>\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_edit), {hash:{},inverse:self.program(32, program32, data),fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              </td>\n              ";
  return buffer;
  }
function program29(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  <ul id=\"attendees\">\n                    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  </ul>\n                ";
  return buffer;
  }
function program30(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    <li data-url=\"";
  if (helper = helpers.event_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.event_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n                      <div class=\"ellipsis\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n                      <button type=\"button\" class=\"cancel_appointment_link\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "remove_attendee_name_55165070", "Remove attendee %{name}", options) : helperMissing.call(depth0, "t", "remove_attendee_name_55165070", "Remove attendee %{name}", options)))
    + "\">\n                        <i class=\"icon-x\" aria-hidden=\"true\"></i>\n                        <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "remove_attendee_name_55165070", "Remove attendee %{name}", options) : helperMissing.call(depth0, "t", "remove_attendee_name_55165070", "Remove attendee %{name}", options)))
    + "</span>\n                      </button>\n                    </li>\n                    ";
  return buffer;
  }

function program32(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  <ul>\n                    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                  </ul>\n                ";
  return buffer;
  }
function program33(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                      <li>";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</li>\n                    ";
  return buffer;
  }

function program35(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <tr>\n          <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.slots_available", "Slots available", options) : helperMissing.call(depth0, "t", "calendar.event_details.slots_available", "Slots available", options)))
    + "</th>\n          <td>";
  if (helper = helpers.availableSlotsText) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.availableSlotsText); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n        </tr>\n      ";
  return buffer;
  }

function program37(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <tr>\n          <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "comments_e07bcbe3", "Comments", options) : helperMissing.call(depth0, "t", "comments_e07bcbe3", "Comments", options)))
    + "</th>\n          <td>";
  if (helper = helpers.reserve_comments) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.reserve_comments); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</td>\n        </tr>\n      ";
  return buffer;
  }

function program39(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(40, program40, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program40(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <tr>\n            <th scope=\"row\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "comments_e07bcbe3", "Comments", options) : helperMissing.call(depth0, "t", "comments_e07bcbe3", "Comments", options)))
    + "</th>\n            <td>\n              <ul>\n                ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(41, program41, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              </ul>\n            </td>\n          </tr>\n        ";
  return buffer;
  }
function program41(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.comments), {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  return buffer;
  }
function program42(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                    <li><em>";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</em>: ";
  if (helper = helpers.comments) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.comments); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</li>\n                  ";
  return buffer;
  }

function program44(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <div class=\"available_slots\">\n        ";
  if (helper = helpers.available_slots_text) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.available_slots_text); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n      </div>\n    ";
  return buffer;
  }

function program46(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"popover-links-holder event-details-footer\">\n      <div class=\"pull-right\">\n        ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(47, program47, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.can_edit), (depth0 && depth0.is_appointment_group), (depth0 && depth0.use_new_scheduler), options) : helperMissing.call(depth0, "ifAll", (depth0 && depth0.can_edit), (depth0 && depth0.is_appointment_group), (depth0 && depth0.use_new_scheduler), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_delete), {hash:{},inverse:self.noop,fn:self.program(49, program49, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_edit), {hash:{},inverse:self.noop,fn:self.program(51, program51, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n      <div class=\"event-details-links\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_reserve), {hash:{},inverse:self.noop,fn:self.program(53, program53, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_unreserve), {hash:{},inverse:self.noop,fn:self.program(55, program55, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_edit), {hash:{},inverse:self.noop,fn:self.program(57, program57, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </div>\n  ";
  return buffer;
  }
function program47(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <a href=";
  if (helper = helpers.editGroupURL) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.editGroupURL); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " class=\"group_details Button Button--small\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "group_details_e51122f1", "Group Details", options) : helperMissing.call(depth0, "t", "group_details_e51122f1", "Group Details", options)))
    + "</a>\n        ";
  return buffer;
  }

function program49(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <button class=\"event_button Button Button--small delete_event_link\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.links.delete", "Delete", options) : helperMissing.call(depth0, "t", "calendar.event_details.links.delete", "Delete", options)))
    + "</button>\n        ";
  return buffer;
  }

function program51(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <button class=\"event_button edit_event_link Button Button--small Button--primary\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.links.edit", "Edit", options) : helperMissing.call(depth0, "t", "calendar.event_details.links.edit", "Edit", options)))
    + "</button>\n        ";
  return buffer;
  }

function program53(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <p>\n            <label for=\"appointment-comment\"><b>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "comments_e07bcbe3", "Comments", options) : helperMissing.call(depth0, "t", "comments_e07bcbe3", "Comments", options)))
    + "</b></label><br />\n            <textarea id=\"appointment-comment\" maxlength=\"255\" name=\"appointment-comment\"></textarea>\n          </p>\n          <button class=\"reserve_event_link Button Button--small Button--link\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.links.reserve", "Reserve", options) : helperMissing.call(depth0, "t", "calendar.event_details.links.reserve", "Reserve", options)))
    + "</strong></button>\n        ";
  return buffer;
  }

function program55(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <button class=\"unreserve_event_link Button Button--small Button--link\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.links.unreserve", "Un-reserve", options) : helperMissing.call(depth0, "t", "calendar.event_details.links.unreserve", "Un-reserve", options)))
    + "</button>\n        ";
  return buffer;
  }

function program57(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reservations), {hash:{},inverse:self.noop,fn:self.program(58, program58, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program58(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <button class=\"message_students Button Button--small Button--link\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.message_students", "Message students", options) : helperMissing.call(depth0, "t", "calendar.event_details.message_students", "Message students", options)))
    + "\n            </button>\n          ";
  return buffer;
  }

  buffer += "<div class=\"event-details carat-bottom\">\n  <div id=\"event-details-trap-focus\">\n  <a href=\"#\" class=\"popover_close x-close-link close\" role=\"button\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.event_details")
  },data:data},helper ? helper.call(depth0, "calendar.event_details.close", "Close", options) : helperMissing.call(depth0, "t", "calendar.event_details.close", "Close", options)))
    + "\">×</a>\n  <div class='event-details-header'>\n    <div class=\"event-type\">";
  if (helper = helpers.eventType) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.eventType); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div>\n    <h2 class=\"details_title title\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.showEventLink), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </h2>\n  </div>\n  <div class=\"event-details-content\">\n    <div class=\"event-details-timestring\">\n      ";
  if (helper = helpers.displayTimeString) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.displayTimeString); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.series_natural_language), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <table cellspacing=\"0\" role=\"presentation\">\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.contextInfo), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.location_name), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.location_address), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.webConference), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.description), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isPlannerNote), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.availableSlotsText), {hash:{},inverse:self.noop,fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.reserve_comments), {hash:{},inverse:self.program(39, program39, data),fn:self.program(37, program37, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </table>\n    <div class=\"details_description lock_explanation\">";
  if (helper = helpers.lock_explanation) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.lock_explanation); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "</div>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.available_slots_text), {hash:{},inverse:self.noop,fn:self.program(44, program44, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.noop,fn:self.program(46, program46, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.can_edit), (depth0 && depth0.can_delete), (depth0 && depth0.can_reserve), (depth0 && depth0.can_unreserve), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.can_edit), (depth0 && depth0.can_delete), (depth0 && depth0.can_reserve), (depth0 && depth0.can_unreserve), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  